import axios from "axios";
import { ENV, validateErrorResponse } from "../config/ENV";
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import axiosInterceptors from "./axiosInterceptors";

const loginRequest = {
  fcmToken:
    "f91ITdTnTCy4AvnsZUdmmG:APA91bEXuIAiwSOMYAsSrn6YR_gLxF4BiPUvt2usrpXsukIebhHB4REYbEWzGb8_Us7ohP8JnX1Pkk6u38jT5WXSYlJY0Sw0WRr8V3bKlkCpaFV6piGNSGwUlj_c2AD7_4Xac6rdjpfs",
};

export default function employeeLoginService() {
  return axiosInterceptors
    .post(ENV.login_url, loginRequest)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

export function employeerAuthService() {
  return axios({
    method: "post",
    url: ENV.login_url,
    headers: {
      Authorization: "Bearer " + window.localStorage.authToken,
    },
    data: loginRequest,
  })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
}

export function saveUserDetails(signUpReqest) {
  return axiosInterceptors
    .post(ENV.signup_url, signUpReqest)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    }); 
}

export function saveUserService() {
  const empCode = window.sessionStorage.getItem("empcode");
  return axiosInterceptors
    .post(ENV.newUserSignup + empCode)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

export function logout() {
  return axiosInterceptors
    .post(ENV.logout_url)
    .then((response) => {
      window.localStorage.setItem("user", "");
      window.localStorage.setItem("authToken", "");
      return response;
    })
    .catch((error) => {
      return error;
    });  
}

export const firebaseLogout = () => {
  firebase
    .auth()
    .signOut()
    .then(function () {
      logout();
      window.localStorage.removeItem("user");
      window.localStorage.removeItem("account");
      window.localStorage.clear();
      window.location.href = "/";
    })
    .catch(function () {});
};
